module.exports = __webpack_public_path__ + "img/lock.22c7873d.svg";